var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-alert',[_vm._v("Not Yet Implemented")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }